import { defineMessages } from "react-intl";

export const scope = "components.Limits";

export const messages = defineMessages({
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: "depositar",
  },
  withdraw: {
    id: `${scope}.withdraw`,
    defaultMessage: "retirar",
  },
  monthly: {
    id: `${scope}.monthly`,
    defaultMessage: "mensuales",
  },
  daily: {
    id: `${scope}.daily`,
    defaultMessage: "diarios",
  },
  yearly: {
    id: `${scope}.yearly`,
    defaultMessage: "anuales",
  },
  monthlySingular: {
    id: `${scope}.monthlySingular`,
    defaultMessage: "mes",
  },
  dailySingular: {
    id: `${scope}.dailySingular`,
    defaultMessage: "dia",
  },
  yearlySingular: {
    id: `${scope}.yearlySingular`,
    defaultMessage: "año",
  },
  aLotRemaining: {
    id: `${scope}.aLotRemaining`,
    defaultMessage:
      "Podés {operation} hasta { remaining } { ticker } este { period }",
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage:
      "(Con la cotización actual podrías {operation} hasta {value} {currency})",
  },
  noRemaining: {
    id: `${scope}.noRemaining`,
    defaultMessage:
      "Alcanzaste el límite de { limit } { ticker } este { period }",
  },
  increaseLimit: {
    id: `${scope}.increaseLimit`,
    defaultMessage: "Aumentar límite",
  },
  ownAccountsReceive: {
    id: `${scope}.ownAccountsReceive`,
    defaultMessage: "desde cuentas propias",
  },
  ownAccountsSend: {
    id: `${scope}.ownAccountsSend`,
    defaultMessage: "hacia cuentas propias",
  },
  thirdPartReceive: {
    id: `${scope}.thirdPartReceive`,
    defaultMessage: "desde cuentas de terceros",
  },
  thirdPartSend: {
    id: `${scope}.thirdPartSend`,
    defaultMessage: "hacia cuentas de terceros",
  },
  link: {
    id: `${scope}.link`,
    defaultMessage: "Más info",
  },
});
